import React from 'react'
import Box from '@mui/material/Box'

import { updatingProps, updatingSx } from './updatingStyle'

export interface UpdatingFadeProps {
  /** The panels inside are showing the previous filter's numbers while the new ones load. */
  updating: boolean
  children: React.ReactNode
  'data-testid'?: string
}

/** Wraps panels that have no box of their own; see updatingStyle.ts. */
export const UpdatingFade: React.FC<UpdatingFadeProps> = ({ updating, children, ...rest }) => (
  <Box {...updatingProps(updating)} data-testid={rest['data-testid']} sx={updatingSx(updating)}>
    {children}
  </Box>
)

export default UpdatingFade
